import {
  STEP_INCREMENT,
  STEP_DECREMENT,
  STEP_DIRECT,
  MOBILE,
  SCROLL_VALUE,
  ERROR_STATE,
  EXP_CHANGE
} from "../actions/types";

const initialState = {
  pageNumber: 0,
  scrollTop: 0,
  desktop: true,
  mobileExp: false,
  errorState: false,
  errorTitle: "Erreure",
  errorMessage: "Une erreure c'est produite !"
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MOBILE:
      return {
        ...state,
        desktop: false
      };
    case STEP_DIRECT:
      if('parentIFrame' in window){
        window.parentIFrame.scrollTo(0);
      }else{
        document.documentElement.scrollTop = 0;
      }
      return {
        ...state,
        pageNumber: action.data,
        scrollTop: 0,
        mobileExp: false
      };
    case STEP_INCREMENT:
      if('parentIFrame' in window){
        window.parentIFrame.scrollTo(0);
      }else{
        document.documentElement.scrollTop = 0;
      }
      return {
        ...state,
        pageNumber: state.pageNumber + 1,
        scrollTop: 0,
        mobileExp: false
      };
    case STEP_DECREMENT:
      if('parentIFrame' in window){
        window.parentIFrame.scrollTo(0);
      }else{
        document.documentElement.scrollTop = 0;
      }
      return {
        ...state,
        pageNumber: state.pageNumber - 1,
        scrollTop: 0,
        mobileExp: false
      };
    case SCROLL_VALUE:
      return {
        ...state,
        scrollTop: action.data
      };
    case ERROR_STATE:
      return {
        ...state,
        errorState: action.data,
        errorTitle: action.title,
        errorMessage: action.message
      };
    case EXP_CHANGE:
      return {
        ...state,
        mobileExp: action.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/step.js